export const RESIZE_THROTTLE = 250;
